var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DialogSlot",
    {
      ref: "approvalModal",
      staticClass: "dialog-slot",
      attrs: {
        id: _vm.id,
        modalBtn: _vm.btnName,
        modalBtnClass: _vm.btnClass,
        showCloseBtn: false,
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "content" }, slot: "content" },
        [
          _c("TextField", {
            staticClass: "handover-approval__textarea",
            attrs: {
              showColon: false,
              label: _vm.$t("comment"),
              value: _vm.comment,
            },
            on: {
              updateValue: function (val) {
                return (_vm.comment = val)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons", attrs: { slot: "buttons" }, slot: "buttons" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn--darkblue",
              attrs: { type: "button" },
              on: { click: _vm.closeModal },
            },
            [_vm._v(_vm._s(_vm.$t("action.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn--orange",
              attrs: { type: "button" },
              on: { click: _vm.btnAction },
            },
            [_vm._v(_vm._s(_vm.btnName))]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }